import React, { useRef } from 'react';
import {
  string,
  number,
  func,
  arrayOf,
  oneOfType
} from 'prop-types';
import { useStoreId } from '@thd-nucleus/experience-context';
import {
  params,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayOfType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';

export const ProductLoader = (props) => {
  const {
    itemId,
    storeId: propStoreId,
    domains,
    children
  } = props;

  const resp = useProductDeprecated({ itemId, domains, skip: !itemId });
  return children(resp);
};

ProductLoader.displayName = 'ShareBeltProductLoader';

ProductLoader.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    info: shapeType({
      fiscalYear: stringType(),
      productDepartment: stringType(),
      classNumber: stringType()
    })
  })
};

ProductLoader.propTypes = {
  children: func.isRequired,
  domains: arrayOf(string).isRequired,
  itemId: oneOfType([string, number]),
  storeId: string
};

ProductLoader.defaultProps = {
  storeId: ''
};

export default ProductLoader;
